import { RpcCredSSPOperation, RpcCredSSPOperationResult } from './rpc-credssp-model';

/**
 * Rpc CredSSP server side handler interface.
 */
export interface RpcCredSspRequestHandler {
    handler(data: RpcCredSSPOperation): Promise<RpcCredSSPOperationResult>;
}
